import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { UserManagementService } from '../../service/user-management.service';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {

  roleDDL: any = [];
  selecteRole: string;
  customerMultiDDL: any[];
  selectedMultiDDL: number[] = [];
  customerSingleDDL: any[];
  selectedSingleDDL: number[] = [];
  user = {
    Id: '',
    UserName: '',
    PhoneNumber: '',
    FirstName: '',
    LastName: '',
    selecteRole: '',
    selectedDDL: [],
    OtpTypeId: 1
  };
  intDDl = {
    value: null,
    label: 'בחירה'
  }
  message: string = '';
  isValid: number = 0;
  msgs: Message[] = [];
  constructor(public dataService: UserManagementService, public router: Router) {
    this.dataService.getRoleDDL().subscribe((res: any) => {
      this.roleDDL = res;
      this.selecteRole = this.roleDDL[0].value;
    });

    this.dataService.getListCustomerDDL().subscribe((res: any) => {
      this.customerMultiDDL = res;
    });

    this.dataService.getListCustomerDDL().subscribe((res: any) => {
      res.unshift(this.intDDl);
      this.customerSingleDDL = res;
    });
  }

  ngOnInit() {
  }

  onSubmit(f: NgForm) {
    if (f.valid) {
      this.isValid = 1;
      this.user.UserName = f.value.UserName;
      this.user.PhoneNumber = f.value.PhoneNumber;
      this.user.FirstName = f.value.FirstName;
      this.user.LastName = f.value.LastName;
      this.user.OtpTypeId = f.value.OtpTypeId;
      this.user.selecteRole = f.value.selecteRole;
      if (f.value.selectedMultiDDL !== undefined) {
        this.user.selectedDDL = this.selectedMultiDDL;
      }
      else if (f.value.selectedSingleDDL !== undefined) {
        this.user.selectedDDL.push(this.selectedSingleDDL);
      }
      this.dataService.insertUser(this.user).subscribe(res => {
        this.message = res.toString();
        if (this.message === '0') {
          this.showSuccess();
          setTimeout(() => {
            location.href = 'create-user';
          }, 1500);
        }
        else if (this.message === '1') {
          this.showErrorSpecific();
        }
        else {
          this.showError();
        }
      }, (err: HttpErrorResponse) => {
        console.log(err);
        if (err && err.error && err.error.ExceptionMessage) {
          this.showMessage('error', '', err.error.ExceptionMessage);
        } else {
          this.showMessage('error', '', 'תקלה ביצירת משתמש חדש');
        }
      });
    }
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: 'נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בשמירה' });
  }

  showErrorSpecific() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שם משתמש כבר בשימוש' });
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/user-management/create-user/create-user.component.ts